import styled from "@emotion/styled";

export const ProcessedTrucksListWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexWrap: "wrap",
	gap: "16px",
	width: "100%"
}));
